import React from 'react';
import '../App.css';
import img1 from '../img/world-outline-t1-120.png'


const aboutSections = [
  {
    img: img1,
    text: 'This domain is dedicated to the Palnau family in the US.',
    imgLeft: true,
  },
  {
    img: null,
    text: 'We may update in the future to explore our family history, share stories, and connect with relatives.',
    imgLeft: null,
  },
  {
    img: null,
    text: 'To contact us, please email:\n\n contact@palnau.us',
    imgLeft: null,
  }
];

export default function About() {
  return (
    <div className="About-page">
      <div className="About-content">
        {aboutSections.map((section, idx) => (
          <div
            className={`About-section ${section.imgLeft ? 'img-left' : section.imgLeft === null ? '' : 'img-right'}`}
            key={idx}
          >
          {section.img &&
          <img src={section.img} alt="" className="About-img" />
          }
            <p style={{ whiteSpace: 'pre-line', width: '100%' }}>{section.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}